/**
 * Expense Category and Status Configuration
 */
import { 
  Plane, 
  Building2, 
  Wrench, 
  GraduationCap, 
  Stethoscope, 
  FileText, 
  Phone, 
  Utensils, 
  MoreHorizontal,
  CheckCircle,
  Clock,
  XCircle
} from 'lucide-react';

export const CATEGORIES = {
  travel: { label: 'Travel', icon: Plane, color: 'text-blue-400', bg: 'bg-blue-500/10' },
  accommodation: { label: 'Accommodation', icon: Building2, color: 'text-amber-400', bg: 'bg-amber-500/10' },
  equipment: { label: 'Equipment', icon: Wrench, color: 'text-slate-400', bg: 'bg-slate-500/10' },
  training: { label: 'Training/Certification', icon: GraduationCap, color: 'text-purple-400', bg: 'bg-purple-500/10' },
  medical: { label: 'Medical', icon: Stethoscope, color: 'text-red-400', bg: 'bg-red-500/10' },
  visa: { label: 'Visa/Documentation', icon: FileText, color: 'text-teal-400', bg: 'bg-teal-500/10' },
  communication: { label: 'Communication', icon: Phone, color: 'text-indigo-400', bg: 'bg-indigo-500/10' },
  subsistence: { label: 'Subsistence/Meals', icon: Utensils, color: 'text-orange-400', bg: 'bg-orange-500/10' },
  other: { label: 'Other', icon: MoreHorizontal, color: 'text-slate-400', bg: 'bg-slate-500/10' }
};

export const REIMBURSEMENT_STATUS = {
  not_claimed: { label: 'Not Claimed', icon: XCircle, color: 'text-slate-400', bg: 'bg-slate-500/20' },
  pending: { label: 'Pending', icon: Clock, color: 'text-amber-400', bg: 'bg-amber-500/20' },
  reimbursed: { label: 'Reimbursed', icon: CheckCircle, color: 'text-amber-400', bg: 'bg-amber-500/20' }
};

export const getCategoryIcon = (category) => {
  const config = CATEGORIES[category] || CATEGORIES.other;
  const IconComponent = config.icon;
  return <IconComponent className={`h-5 w-5 ${config.color}`} />;
};

export const getStatusBadge = (status) => {
  const config = REIMBURSEMENT_STATUS[status] || REIMBURSEMENT_STATUS.not_claimed;
  const IconComponent = config.icon;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${config.bg} ${config.color}`}>
      <IconComponent className="h-3 w-3" />
      {config.label}
    </span>
  );
};
